import type { EntryPointComponent } from 'react-relay';
import { fg } from '@atlassian/jira-feature-gating';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import type { RouteResources } from '@atlassian/react-resource-router';
import { MenuIdFilters } from '@jira/navigation-apps__constants/src/MenuIdFilters.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import type { LegacyEntryRoute } from '@jira/platform__routing-route-entry/src/createLegacyEntry.tsx';
import { createLegacyEntry } from '@jira/platform__routing-route-entry/src/createLegacyEntry.tsx';
import { RootLifecycleEntryPointContainer } from '@jira/platform__spa/src/view/RootLifecycleEntryPointContainer.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { LegacyPage } from '@jira/router-routes__common/src/ui/legacy-page/main.tsx';
import { globalIssueNavigatorRedirectRoute } from '@jira/router-routes__legacy-global-issue-navigator-routes/src/globalIssueNavigatorRedirectRoute.tsx';

const globalIssueNavigatorRedirectMigrationEmptyProps = {};
const globalIssueNavigatorRedirectMigrationEntryPoint0 = createPageEntryPoint({
	main: {
		root: JSResourceForUserVisible<EntryPointComponent<{}, {}, {}, {}>>(
			/* webpackChunkName: "async-globalIssueNavigatorRedirect-0" */ './GlobalIssueNavigatorRedirectRoot.tsx',
			{ entryFsSsrLiftImportToModule: true },
		),
		getPreloadProps: () => globalIssueNavigatorRedirectMigrationEmptyProps,
	},
});

export const globalIssueNavigatorRedirectRouteEntry: LegacyEntryRoute<RouteResources> =
	createLegacyEntry(globalIssueNavigatorRedirectRoute, () => ({
		canTransitionIn: () => false,

		// eslint-disable-next-line no-restricted-syntax
		component: fg('nike_entrypoint_migration_batch_9') ? undefined : LegacyPage,

		layout: globalLayout,

		navigation: {
			menuId: MenuIdFilters,
		},

		resources: [...getNavigationResources(), navigationSidebarGlobalResource],
		entryPoint: () =>
			fg('nike_entrypoint_migration_batch_9')
				? globalIssueNavigatorRedirectMigrationEntryPoint0
				: undefined,
		entryPointContainer: fg('nike_entrypoint_migration_batch_9')
			? RootLifecycleEntryPointContainer
			: undefined,
	}));
